import React, { useMemo } from "react";

import {
  getDefaultCountry,
  getPhoneInputCountries,
  toIsdSelectOptions,
} from "constants/countryConfig";
import { DEFAULT_ISD_CODE, getPhoneConfigForIsd } from "constants/phoneConfig";
import SingleSelect from "../Dropdown/SingleSelect";
import Textfield from "../Textfield/Textfield";

import styles from "./PhoneWithIsdInput.module.scss";

const PhoneWithIsdInput = ({
  phone,
  onPhoneChange,
  isdCode: isdCodeProp,
  onIsdCodeChange,
  phoneLabel = "Phone Number",
  disabled = false,
}) => {
  const phoneInputCountries = useMemo(() => getPhoneInputCountries(), []);
  const menuItems = useMemo(
    () => toIsdSelectOptions(phoneInputCountries),
    [phoneInputCountries],
  );
  const selectedIsdCode =
    isdCodeProp || getDefaultCountry()?.isdCode || DEFAULT_ISD_CODE;
  const phoneConfig = getPhoneConfigForIsd(selectedIsdCode);

  return (
    <div className={styles.container}>
      <div className={styles.isdSelect}>
        <SingleSelect
          id="country-isd-select"
          name="isdCode"
          placeholder={selectedIsdCode}
          value={selectedIsdCode}
          menuItems={menuItems}
          handleChange={(event) => {
            const nextIsdCode = event.target.value;
            onIsdCodeChange?.(nextIsdCode);
            onPhoneChange("");
          }}
          disabled={disabled}
        />
      </div>
      <div className={styles.phoneField}>
        <Textfield
          label={phoneLabel}
          fullWidth
          margin="normal"
          value={phone}
          disabled={disabled}
          onChange={(event) => {
            const digitsOnly = (event.target.value || "")
              .replace(/\D/g, "")
              .slice(0, phoneConfig.maxLength);
            onPhoneChange(digitsOnly);
          }}
        />
      </div>
    </div>
  );
};

export default PhoneWithIsdInput;
